import PropTypes from 'prop-types';
import styles from './UploadPricingOptionsModal.module.scss';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import RetailerIdsListModal from '../RetailerIdsListModal/RetailerIdsListModal';

export function UploadPricingOptionsModal(props) {
  const { onUpload } = props;
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const onClose = () => {
    setFile(null);
    inputRef.current.value = '';
    props.onClose();
  };

  const onSubmit = () => {
    dispatch(onUpload(file));
    setFile(null);
    onClose();
  };

  return (
    <>
      <div className={styles.wrapper}>
        <label htmlFor="file">Select a file to upload:</label>
        <div className={styles.fileWrapper}>
          <button className={styles.button}>Choose File</button>
          {file && <span className={styles.fileName}>{file.name}</span>}
          <input
            id="file"
            type="file"
            accept=".tsv,.csv"
            onChange={(e) => {
              setFile(e.target.files[0]);
            }}
            ref={inputRef}
          />
        </div>
        <hr />
        <div className={styles.examples}>
          <button className={styles.buttonLink} onClick={() => setModalOpen(true)}>
            Retailers IDs list
          </button>
          <div className={styles.example}>
            <a
              href="https://docs.google.com/spreadsheets/d/1G9yQhkZKbPdASjFcIwf7PBAyBDcSj4LtO2egaywrHB8/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Example file for Dropship
            </a>
          </div>
          <div className={styles.example}>
            <a
              href="https://docs.google.com/spreadsheets/d/1_S8QFy2Z6Yf_gMFuF7GMP_srFiGILX7-pku3OSbpAa8/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Example file for Marketplace
            </a>
          </div>
          <p>Please note, price updates might take up to an hour.</p>
        </div>
        <footer>
          <button type="button" className={styles.button} onClick={onClose}>
            Close
          </button>

          <button type="button" className={styles.button} disabled={!file} onClick={onSubmit}>
            Upload
          </button>
        </footer>
      </div>

      <RetailerIdsListModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}

UploadPricingOptionsModal.propTypes = {
  onUpload: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
